module.exports = __webpack_public_path__ + "static/media/fastSpeed.6e0c4847.svg";